<p-dialog
    [visible]="true"
    [modal]="true"
    styleClass="center-header m-dialog-header-text"
    appendTo="body"
    header = "Please select a {{ namingConvService.endUserSingular }}"
    [resizable] ="false"
    [closable]="false"
    [style]="{ 'max-width': '450px', width: '100%' }"
    styleClass="center-header m-dialog-header-text">
    <div class="inputs-group pt-2">
        <div class="inputs-group-row">
            <patient-select
                #patientSelect
                [showAddButton]="false"
                [autoSelectNewPatient]="false"
                [(ngModel)]="patientId">
             </patient-select>

        </div>
    </div>

    <form-buttons allowOffline [disabled]="!patientId" [config]="buttonsConfig"></form-buttons>
</p-dialog>

